// color
export const RED = '#ee0a24'
export const BLUE = '#1989fa'
export const GREEN = '#07c160'
export const WHITE = '#fff'

// border
export const BORDER = 'van-hairline'
export const BORDER_TOP = `${BORDER}--top`
export const BORDER_LEFT = `${BORDER}--left`
export const BORDER_BOTTOM = `${BORDER}--bottom`
export const BORDER_SURROUND = `${BORDER}--surround`
export const BORDER_TOP_BOTTOM = `${BORDER}--top-bottom`
export const BORDER_UNSET_TOP_BOTTOM = `${BORDER}-unset--top-bottom`
